import React, { useEffect } from "react";
import RootStack from "./navigation/RootStack";
import AuthProvider from "./providers/AuthProvider";
import { Provider } from "react-redux";
import { store, updateIsConnected } from "@lib";
import NetInfo from "@react-native-community/netinfo";
import DeviceInfo from "react-native-device-info";
import Orientation from "react-native-orientation-locker";
import ToastWrapper from "./components/common/ToastsWrapper";
import { changeFavicon } from "@lib/utilities/Helpers";
import { Platform } from "react-native";
import { APP_ICON } from "./resources/IMAGES";
import { useAppUpdate } from "@lib/hooks/app-update/useAppUpdate";
import AppUpdateComp from "./components/app-update/AppUpdateComp";
import FullScreenLoader from "./components/common/FullScreenLoader";

const App = () => {
  useEffect(() => {
    const isTablet = DeviceInfo.isTablet();

    if (isTablet) {
      Orientation.unlockAllOrientations();
    } else {
      Orientation.lockToPortrait();
    }

    if (Platform.OS == "web") {
      changeFavicon(APP_ICON);
    }

    return () => {
      Orientation.lockToPortrait();
    };
  }, []);

  useEffect(() => {
    const unsubscribe = NetInfo.addEventListener((state) => {
      store.dispatch(updateIsConnected(state?.isConnected ?? true));
    });

    return () => unsubscribe();
  }, []);

  const {
    updateAvailable,
    handleSkipUpdate,
    updateTitle,
    updateDescription,
    updateVersion,
    updateReleaseNotes,
    forced,
    isLoading,
  } = useAppUpdate();

  return (
    <Provider store={store}>
      <AuthProvider>
        {updateAvailable && (
          <AppUpdateComp
            onLaterPress={handleSkipUpdate}
            updateTitle={updateTitle}
            updateDescription={updateDescription}
            updateVersion={updateVersion}
            updateReleaseNotes={updateReleaseNotes}
            forced={forced}
          />
        )}
        <RootStack />
      </AuthProvider>
      <ToastWrapper />
      {isLoading && <FullScreenLoader screenName="" />}
    </Provider>
  );
};

export default App;
